import { render } from "./HomeWorkspace.vue?vue&type=template&id=de27a920&scoped=true"
import script from "./HomeWorkspace.vue?vue&type=script&lang=js"
export * from "./HomeWorkspace.vue?vue&type=script&lang=js"

import "./HomeWorkspace.vue?vue&type=style&index=0&id=de27a920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de27a920"]])

export default __exports__